import React, { useState, useEffect } from 'react';
import style from './PillAlarm.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import SwitchBox from '../../../../../components/box/SwitchBox';
import CustomTimePicker from '../../../../../components/datepicker/CustomTimePicker';
import Modal from '../../../../../components/comm/Modal';
import day_morning from '../../../../../images/common/i_day_morning_02.svg';
import day_lunch from '../../../../../images/common/i_day_lunch_02.svg';
import day_night from '../../../../../images/common/i_day_night_02.svg';
import noDataImg from '../../../../../images/common/i_3d_no_data_doc.svg';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import { getPillAlarmTime, toPillTm } from '../../../../../constants/pillEraTime';

import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

import Skeleton from '@mui/material/Skeleton';


const updateMedicationAlarm = async (updateData) => {
  const url = "/homecare/tkmdcn/saveAlarmUserTakingMedicineInfo";
  const jToken = localStorage.getItem('jToken');
  const loginUser = JSON.parse(sessionStorage.getItem('loginUser') || '{}');

  const reqBody = {
    usrInfoId: loginUser.usrInfoId,
    usrTkmedicnInfoId: updateData.usrTkmedicnInfoId,
    ...(updateData.alrmAt !== undefined && { alrmAt: updateData.alrmAt }),
    ...(updateData.reAlrmAt !== undefined && { reAlrmAt: updateData.reAlrmAt }),
    ...(updateData.alrmSetupTm !== undefined && { alrmSetupTm: updateData.alrmSetupTm })
  };

  const requestOption = {
    headers: {
      "Authorization": `Bearer ${jToken}`,
    },
  };

  console.log('reqBody:', reqBody);
  // return

  try {
    const res = await axiosApi.post(url, reqBody, requestOption);
    if (res.data.resultCode === CODE.RCV_SUCCESS) {
      return true;
    } else {
      console.warn("업데이트 실패:", res.data.resultMessage);
      return false;
    }
  } catch (err) {
    console.error("업데이트 API 호출 중 오류", err);
    return false;
  }
};

const PillAlarm = () => {
  const [alarmList, setAlarmList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [pendingToggleId, setPendingToggleId] = useState(null);
  const [isGlobalToggle, setIsGlobalToggle] = useState(false);
  const [openPickerFor, setOpenPickerFor] = useState(null);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    searchTakingMedicineRecordList();
  }, []);

  /* 	@Operation(summary = "사용자 복약 기록 목록 조회") */
  const searchTakingMedicineRecordList = () => {

    setLoading(true);

    const user = JSON.parse(sessionStorage.getItem("loginUser"));
    const requestUrl = "/homecare/tkmdcn/retrieveUserTakingMedicineRecordingList";
    const jToken = localStorage.getItem("jToken");

    const requestOption = {
      headers: {
        "Authorization": `Bearer ${jToken}`,
      },
    };

    const requestBody = {
      usrInfoId: user?.usrInfoId,
      usrHsptlMap: user?.usrHsptlMap
    };

    axiosApi.post(requestUrl, requestBody, requestOption)

      .then((res) => {
        const resultData = res.data;
        if (resultData.resultCode === CODE.RCV_SUCCESS) {
          const transformedList = resultData.result.usrTkmdcnRecList.map(item => {
            const pillList = item.tkmdcnCn ? item.tkmdcnCn.split('@,@') : [];

            return {
              id: item.usrTkmedicnInfoId,
              periodName: item.tkmdcnEraNm,
              imgSrc: getImgSrc(item.tkmdcnEraNm),
              time: getPillAlarmTime(item),
              switchOn: item.alrmAt === '1',
              repeatOn: item.reAlrmAt === '1',
              timing: item.tkmdcnMthCn || '',
              pillList: pillList,
              body: item.tkmdcnCn,
              tkmdcnGrpCd: item.tkmdcnGrpCd,
              tkmdcnEraCd: item.tkmdcnEraCd,
              usrTkmedicnInfoId: item.usrTkmedicnInfoId
            };
          });
          setAlarmList(transformedList);
        } else {
          setAlarmList([]);
        }
      })
      .catch((err) => {
        console.log("=========> err : ", err);
        setAlarmList([]);
      })
      .finally(() => {
        setLoading(false);
      })
  };

  const getImgSrc = (periodName) => {
    if (periodName === '아침') return day_morning;
    if (periodName === '점심') return day_lunch;
    return day_night;
  };

  const allOn = alarmList.length > 0 && alarmList.every(alarm => alarm.switchOn);

  const formatTime = (hour, minute) => {
    const ampm = hour < 12 ? '오전' : '오후';
    const hr = hour % 12 === 0 ? 12 : hour % 12;
    const min = String(minute).padStart(2, '0');
    return `${ampm} ${hr}:${min}`;
  };

  const toggleAll = async (status) => {
    if (!status) {
      setIsGlobalToggle(true);
      setIsOpen(true);
    } else {
      const promises = alarmList.map(alarm =>
        updateMedicationAlarm({
          usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
          alrmAt: '1',
          alrmSetupTm: toPillTm(alarm.time)
        })
      );

      const results = await Promise.all(promises);

      if (results.every(r => r)) {
        setAlarmList(prev => prev.map(alarm => ({ ...alarm, switchOn: true })));
      } else {
        alert("일부 알림 설정에 실패했습니다.");
      }
    }
  };

  const toggleAlarmSwitch = async (id, status) => {
    if (!status) {
      setPendingToggleId(id);
      setIsOpen(true);
    } else {
      const alarm = alarmList.find(a => a.id === id);

      const success = await updateMedicationAlarm({
        usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
        alrmAt: '1',
        alrmSetupTm: toPillTm(alarm.time)
      });

      if (success) {
        setAlarmList(prev =>
          prev.map(a =>
            a.id === id ? { ...a, switchOn: true } : a
          )
        );
      } else {
        alert("알림 설정에 실패했습니다.");
      }
    }
  };
  const toggleRepeatSwitch = async (id, status) => {
    const alarm = alarmList.find(a => a.id === id);

    const success = await updateMedicationAlarm({
      usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
      reAlrmAt: status ? '1' : '0'
    });

    if (success) {
      setAlarmList(prev =>
        prev.map(a =>
          a.id === id ? { ...a, repeatOn: status } : a
        )
      );
    } else {
      alert("다시 알림 설정에 실패했습니다.");
    }
  };

  const onConfirmTime = async (id, time) => {
    const alarm = alarmList.find(a => a.id === id);
    const oldTime = alarm.time;

    const formattedTime =
      String(time.hour).padStart(2, '0') +
      String(time.minute).padStart(2, '0') +
      '00'; // 항상 00초 고정 (예: 113000)

    setAlarmList(prev =>
      prev.map(a =>
        a.id === id ? { ...a, time } : a
      )
    );

    const success = await updateMedicationAlarm({
      usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
      alrmSetupTm: formattedTime
    });

    if (!success) {
      alert("시간 변경에 실패했습니다.");
      setAlarmList(prev =>
        prev.map(a =>
          a.id === id ? { ...a, time: oldTime } : a
        )
      );
    }

    setOpenPickerFor(null);
  };


  const onDismiss = () => {
    setOpenPickerFor(null);
  };

  const confirmTurnOffAlarm = async () => {
    if (isGlobalToggle) {
      const alarmsWithRepeat = alarmList.filter(alarm => alarm.repeatOn);

      if (alarmsWithRepeat.length > 0) {
        const repeatPromises = alarmsWithRepeat.map(alarm =>
          updateMedicationAlarm({
            usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
            reAlrmAt: '0'
          })
        );
        await Promise.all(repeatPromises);
      }

      const promises = alarmList.map(alarm =>
        updateMedicationAlarm({
          usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
          alrmAt: '0'
        })
      );

      const results = await Promise.all(promises);

      if (results.every(r => r)) {
        setAlarmList(prev => prev.map(alarm => ({ ...alarm, switchOn: false, repeatOn: false })));
      } else {
        alert("일부 알림 끄기에 실패했습니다.");
      }
    } else if (pendingToggleId) {
      const alarm = alarmList.find(a => a.id === pendingToggleId);

      if (alarm.repeatOn) {
        await updateMedicationAlarm({
          usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
          reAlrmAt: '0'
        });
      }

      const success = await updateMedicationAlarm({
        usrTkmedicnInfoId: alarm.usrTkmedicnInfoId,
        alrmAt: '0'
      });

      if (success) {
        setAlarmList(prev =>
          prev.map(a =>
            a.id === pendingToggleId ? { ...a, switchOn: false, repeatOn: false } : a
          )
        );
      } else {
        alert("알림 끄기에 실패했습니다.");
      }
    }

    setIsOpen(false);
    setPendingToggleId(null);
    setIsGlobalToggle(false);
  };

  const cancelTurnOffAlarm = () => {
    setIsOpen(false);
    setPendingToggleId(null);
    setIsGlobalToggle(false);
  };

  return (
    <>
      <HeadSub title="복약 기록 알림 설정" />

      <div className={style['top-bar-box']}>
        <span>전체 알림</span>
        <SwitchBox status={toggleAll} toggles={allOn} />
      </div>

      <div id="sub-content" data-type="a">
        <div className="inner-wrap" data-pad="normal">

          {loading ? (
            // 스켈레톤 로딩
            <>
              {[1, 2, 3].map((item) => (
                <div className={style['pill-alarm-box']} key={item}>
                  <div className={style['innerbox']}>
                    <div className={style['period-box']}>
                      <Skeleton variant="text" width={50} height={24} style={{ display: 'inline-block', borderRadius: '8px' }} />
                      <Skeleton variant="text" width={50} height={24} style={{ display: 'inline-block', borderRadius: '8px' }} />
                    </div>
                    <Skeleton variant="text" width="60%" />
                    <div className={style['alarm-box']}>
                      <Skeleton variant="text" width="30%" />
                      <Skeleton variant="text" width="40%" />
                    </div>
                    <div className={style['alarm-box']}>
                      <Skeleton variant="text" width="20%" />
                      <Skeleton variant="text" width="50%" />
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : alarmList.length === 0 ? (
            <div className={style['no-data-box']}>
              <div className={style['img-box']}>
                <object data={noDataImg} aria-hidden='true'></object>
              </div>
              <p> 등록된 알림이 없습니다.</p>
            </div>
          ) : (
            <>
              <div className={style['check-point-box']}>
                <strong>꼭 확인해주세요!</strong>
                <ul>
                  <li>알림이 적용되기까지 최대 30분 정도 걸릴 수 있습니다.</li>
                </ul>
              </div>
              {alarmList.map(({ usrTkmedicnInfoId, id, periodName, imgSrc, time, switchOn, repeatOn, timing, pillList, body, tkmdcnGrpCd }) => (
                <div className={style['pill-alarm-box']} key={usrTkmedicnInfoId}>
                  <div className={style['innerbox']}>
                    <div className={style['period-box']}>
                      <span>
                        <img src={imgSrc} alt={periodName} />
                        {periodName}
                      </span>
                      {timing && <span>{timing}</span>}
                    </div>
                    <div className={style['pill-name-box']}>
                      <span>{pillList.length > 0 ? pillList.join(', ') : body}</span>
                    </div>
                    <div className={style['alarm-box']}>
                      <strong
                        className={!switchOn ? style['no-alarm'] : ''}
                        onClick={() => switchOn && setOpenPickerFor(id)}
                        style={{ cursor: 'pointer' }}
                      >
                        {formatTime(time.hour, time.minute)}
                      </strong>

                      {tkmdcnGrpCd !== 'G20' &&
                        <div data-swich-size="sm">
                          <SwitchBox status={status => toggleAlarmSwitch(id, status)} toggles={switchOn} />
                        </div>
                      }
                    </div>
                    <div className={style['infom-wrap']}>
                      {switchOn && (
                        <div className="animation-1">
                          <div className={style['infom-box']}>
                            <p className={style['tit']}>다시 알림 설정</p>
                            <SwitchBox size="small" status={status => toggleRepeatSwitch(id, status)} toggles={repeatOn} />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}

          <BottomSheet
            scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
            expandOnContentDrag={false} // 내용 드래그로 확장 방지
            open={openPickerFor !== null}
            onDismiss={onDismiss}
            snapPoints={({ minHeight }) => minHeight}
            blocking={true}
          >
            {openPickerFor !== null && (() => {
              const targetAlarm = alarmList.find(a => a.id === openPickerFor);
              const initTime = targetAlarm?.time || { hour: 9, minute: 0 }; // fallback

              console.log('initTime:', initTime);
              return (
                <CustomTimePicker
                  onClose={onDismiss}
                  onConfirm={time => onConfirmTime(openPickerFor, time)}
                  titleTxt="알림 시간 선택"
                  initialTime={initTime}
                />
              );
            })()}
          </BottomSheet>


          <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="modal-box" data-type="a">
              <div className="modal-top-box">
                <div className="title-box">
                  <p> 알림을 끄시겠어요?</p>
                </div>
              </div>

              <div className="modal-bottom-box">
                <div className="btn-layout">
                  <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelTurnOffAlarm}>
                    <span>취소</span>
                  </button>
                  <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={confirmTurnOffAlarm}>
                    <span>끄기</span>
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default PillAlarm;